import React from "react";

const CenteredHeading = (props) => {
  return (
    <h2 className="text-2xl text-dark-blue font-poppins font-bold pb-5 pt-2 text-center max-lg:text-lg max-sm:text-[15px] 2xs:max-md:bg-white">
      {props.title}
    </h2>
  );
};

export default CenteredHeading;
